<template>
  <v-main class="vapp-root">
    <v-container style="width: 660px; position: absolute; top: 15%; right: 5%">
      <div class="text-right">
        <!--<v-btn
          class="white--text font-weight-bold font-size-16"
          text
          href="http://hisolardesign.hyundai-es.co.kr/"
          >하이솔라디자인</v-btn
        >-->
        <v-btn
          class="white--text font-weight-bold font-size-16"
          text
          href="https://www.hd-hyundaies.co.kr/"
          >HD현대에너지솔루션</v-btn
        >
      </div>
      <v-card elevation="0" class="pd20" light style="background-color: #fff;">
        <v-card-title class="pd_title">
          <font class="font-weight-bold font-size-36" color="#0784F2"
            >LOGIN</font
          >
        </v-card-title>
        <v-card-text class="pa-0">
          <span class="pb-1 font-size-16">아이디</span>
          <v-text-field
            background-color="#E6ECF3"
            solo
            height="48"
            hide-details
            dense
            placeholder="아이디를 입력하세요"
            v-model="userId"
          ></v-text-field>
          <span class="pb-1 font-size-16">비밀번호</span>
          <v-text-field
            background-color="#E6ECF3"
            solo
            height="48"
            hide-details
            dense
            type="password"
            placeholder="비밀번호를 입력하세요"
            @keyup.enter="signIn"
            v-model="userPassword"
          ></v-text-field>
        </v-card-text>
        <v-card-text class="pa-0 d-flex">
          <v-checkbox
            class="mt-0 pr-4"
            v-model="is_saved"
            color="gray"
            hide-details
          >
            <template v-slot:label>
              <span class="font-size-12">아이디저장</span>
            </template>
          </v-checkbox>
          <!-- <v-checkbox class="mt-0" v-model="isAutoLogin" color="gray" hide-details>
            <template v-slot:label>
              <span class="font-size-12">자동로그인</span>
            </template>
          </v-checkbox> -->
        </v-card-text>
        <v-spacer></v-spacer>
        <v-row>
          <v-col>
            <v-btn class="big-menu-btn unified-bg flex-grow-1" block @click="signIn"
              >로그인</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center align-center py-0" style="gap: 8px;">
            <v-btn
              depressed
              class="big-menu-btn unified-bg flex-grow-1"
              @click="moveFindIdPw('id')"
            >
              아이디 찾기
            </v-btn>
            <v-btn
              depressed
              class="big-menu-btn unified-bg flex-grow-1"
              @click="moveFindIdPw('pw')"
            >
              비밀번호 찾기
            </v-btn>
            <v-btn
              depressed
              class="big-menu-btn unified-bg flex-grow-1"
              to="/regist"
            >
              회원가입
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          <v-row justify-space-between class="mb-35">
            <v-col cols="6">
              <span class="requestAsColor font-size-16"> 제품문의 및 AS </span>
              <span class="numberColor callNum">1522-5001</span>
            </v-col>
          </v-row>
        </v-row>
        <v-card elevation="0" width="100%" style="background-color: #fff;">
          <v-flex>
            <v-row>
              <v-col cols="6">
                <v-card class="bs_n" style="background-color: #fff;">
                  <v-card-title class="btmLine">
                    <span class="notice-title-style notice-color">NOTICE</span>
                    <span class="notice-color">공지사항</span>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-skeleton-loader
                      max-width="100%"
                      type="list-item-two-line,list-item-two-line"
                      v-if="noticeList.length <= 0"
                    >
                    </v-skeleton-loader>
                    <v-simple-table class="cursor" dense light>
                      <tbody>
                        <tr
                          v-for="(item, index) in noticeList"
                          :key="index"
                          @click="toggleContext(index)"
                        >
                          <td class="date">{{ item.insdate }}</td>
                          <td class="board_title">
                            <div class="context-list-title">
                              {{ item.title }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="bs_n" style="background-color: #fff;">
                  <v-card-title class="btmLine">
                    <span class="notice-title-style resource-color"
                      >RESOURCE</span
                    >
                    <span class="resource-color">자료실</span>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-skeleton-loader
                      max-width="100%"
                      type="list-item-two-line,list-item-two-line"
                      v-if="resourceList < 0"
                    >
                    </v-skeleton-loader>
                    <v-simple-table class="cursor" dense light>
                      <tbody>
                        <tr
                          v-for="(item, index) in resourceList"
                          :key="index"
                          @click="showResource(index)"
                        >
                          <td class="date" style="border-bottom-width: 0">
                            {{ item.insdate.slice(0, 11) }}
                          </td>
                          <td
                            class="board_title"
                            style="border-bottom-width: 0"
                          >
                            {{ item.title }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-flex>
        </v-card>
      </v-card>
      <v-row>
        <v-col class="white--text text-caption" cols="8">
          <span class="text-left"
            >(13553) 경기도 성남시 분당구 분당수서로 477, 9층 (정자동, GRC
            센터)</span
          >
          <p class="txt">
            Copyrights ⓒ HD Hyundai Energy Solutions Co.,Ltd.All Rights
            Reserved.
          </p>
        </v-col>
        <v-col>
          <span
            ><v-btn
              x-small
              txt
              link
              outlined
              class="pa-0 text-caption"
              style="background:rgba(255,255,255,0.3);"
              color="rgba(255,255,255,0.7)"
              href="https://www.hd-hyundaies.co.kr/private/policy.do"
              >개인정보처리방침</v-btn
            ></span
          >
          <!-- <p><v-btn
            x-small
            txt
            link
            outlined
            class="pa-0 text-caption"
            style="background:rgba(255,255,255,0.3);"
            color="rgba(255,255,255,0.7)"
            to="/VideoInformationPolicy"
          >영상정보처리기기운영관리방침</v-btn></p> -->
        </v-col>
      </v-row>
      <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
        <v-card flat>
          <v-card-text>
            <v-form ref="CertificateForm">
              <v-row>
                <v-col
                  cols="12"
                  class="pt-0"
                  v-show="!showCheckEmail"
                  v-if="loginCount > 4"
                >
                  <span class="text-caption"
                    >비밀번호를 5회 이상 틀리셨습니다. 2차 인증이
                    필요합니다</span
                  >
                </v-col>
                <v-col cols="12" class="pt-0" v-show="showCheckEmail">
                  <span class="text-caption"
                    >등록하신 이메일로 인증번호가 발송되었습니다. 발송된
                    인증번호를 입력해주세요.</span
                  >
                </v-col>
                <v-col cols="7" md="8" v-if="true">
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    v-model="certificateNumber"
                    label="인증번호"
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  class="pl-0 align-self-center"
                  cols="5"
                  md="4"
                  v-if="!showCheckEmail"
                >
                  <v-btn
                    outlined
                    class="default-btn"
                    :disabled="disableSendEmail"
                    v-show="!disableSendEmail"
                    block
                    @click="sendEmail"
                    >인증번호발송</v-btn
                  >
                </v-col>
                <v-col class="pl-0 align-self-center" cols="5" md="4" v-else>
                  <v-btn outlined class="default-btn" block @click="sendEmail"
                    >재전송</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </general-dialog>
      <open-alert-dialog :show-event="showAlert"></open-alert-dialog>
      <notice-dialog
        white
        :type="context.type"
        :context="context"
        :show-event="showContext"
      ></notice-dialog>
      <resource-dialog
        white
        :toggle-popup="showResourcePopup"
        :board="selectBoard"
      ></resource-dialog>
      <!--<v-dialog v-model="component_show" max-width="900px">
        <v-card class="top_title"> &nbsp; 공지사항</v-card>
          <v-card>
            <span>
              &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
              <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
            </span>
          </v-card>
        <div class="main_content">
          <a href="https://naver.me/GHLLjA6X" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/image/popup.jpg" width="100%">
          </a>
        </div>
      </v-dialog>-->
    </v-container>
  </v-main>
</template>

<script>
import store from '@/store'
import Cookies from 'js-cookie'
import OpenAlertDialog from '@/components/monitoring/OpenAlertDialog'
import NoticeDialog from '@/components/monitoring/NoticeDialog'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import { getNoticeList, getResourceList } from '@/api/greenCommon/common'
import {
  checkForEmail,
  certificateForEmail,
  resetLoginCount
} from '@/api/common/login'
import Message from '@/utils/message'
import router from '@/router'
import ResourceDialog from '@/components/monitoring/ResourceDialog'
import localStore from '@/utils/localStore'

export default {
  components: {
    OpenAlertDialog,
    NoticeDialog,
    GeneralDialog,
    ResourceDialog
  },
  data() {
    return {
      isAutoLogin: false,
      component_show: false,
      retrieveData: {
        title: '', // 제목
        contents: '', // 상세내용
        create_user_name: '', // 작성자
        itemsPerPage: 4,
        currentPage: 1 // 현재 페이지
      },
      popupTitle: '사용자 인증',
      modal: false,
      certificateNumber: '',
      email: '',
      loginCount: '',
      showCheckEmail: false,
      disableSendEmail: false,
      buttons: [
        {
          title: '인증번호확인',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup()
          }
        }
      ],
      context: {
        type: 'notice',
        title: '',
        date: '',
        context: ''
      },
      showContext: false,
      showAlert: false,
      showResourcePopup: false,
      title: 'LOGIN',
      userId: '',
      userPassword: '',
      idEmpty: false,
      pwEmpty: false,
      idPwCheck: false,
      is_saved: true,
      noticeList: [],
      resourceList: [],
      selectBoard: {}
    }
  },
  created() {
    if (Cookies.get('autoLogin') !== undefined) {
      let data = Cookies.get('autoLogin').split('[####]')
      store
        .dispatch('LoginByPassword', {
          userId: data[0],
          userPassword: atob(data[1])
        })
        .then(response => {
          this.$store.dispatch('SetUserInfo').then(response => {
            this.$store.dispatch('GetUserMenus', store.state.user.userId)
            this.moveMonitoringPage()
          })
        })
        .catch(reject => {
          Message.err('아이디 또는 비밀번호가 다릅니다.')
          router.replace('/login')
        })
    }
    getNoticeList(this.retrieveData).then(res => {
      this.noticeList = res
    })
    let params = {
      count: 4
    }
    getResourceList(params).then(res => {
      this.resourceList = res
    })
    this.init_page()
  },
  mounted() {
    this.initPopup()
  },
  methods: {
    moveMonitoringPage() {
      let grpCd = localStore.get('grp_auth')
      if (
        grpCd === 'usergroup008' || // 시운전
        grpCd === 'usergroup007' || // 시운전
        grpCd === 'usergroup006'
      ) {
        this.$router.replace('/constructor') // 시공사화면
      } else if (
        grpCd === 'usergroup001' || // 관리자
        grpCd === 'usergroup002' || // 본사
        grpCd === 'usergroup003' || // 대리점
        grpCd === 'usergroup004' // AS기사
      ) {
        this.$router.replace('/centeras') // AS 화면
        // this.$router.replace('/siteWork?site_id=' + 'M1307') // 통신카드 TEST ROUTE 2025-01-23 일시 비활성화
      } else {
        if (store.state.user.site_cnt === 1) {
          let siteId = store.state.user.site_id
          if (siteId.indexOf('E') > -1) {
            this.$router.replace('/ess/siteWork?site_id=' + siteId)
          } else {
            this.$router.replace('/siteWork?site_id=' + siteId)
          }
        } else {
          this.$router.replace('/personalmonitoring') // 개인화면
        }
      }
    },
    moveFindIdPw(type) {
      this.$router.push({ name: 'FindIdPw', query: { type: type } })
    },
    toggleAlert() {
      this.showAlert = !this.showAlert
    },
    init_page() {
      if (Cookies.get('saveID') !== undefined) {
        this.userId = Cookies.get('saveID')
        this.is_saved = true
      } else {
        this.is_saved = false
      }

      if (Cookies.get('autoLogin') !== undefined) {
        this.isAutoLogin = true
      } else {
        this.isAutoLogin = false
      }
    },
    signIn() {
      if (this.userId === '') {
        this.idEmpty = true
        this.pwEmpty = false
        this.idPwCheck = false
        Message.warn('아이디를 입력해주세요.')
        return
      }

      if (this.userPassword === '') {
        this.idEmpty = false
        this.pwEmpty = true
        this.idPwCheck = false
        Message.warn('비밀번호를 입력해주세요.')
        return
      }
      // store에 정의한 Login을 사용한다.
      store
        .dispatch('LoginByPassword', {
          userId: this.userId,
          userPassword: this.userPassword
        })
        .then(response => {
          // Login이 완료될 경우
          this.pwEmpty = false
          this.idEmpty = false
          this.idPwCheck = false

          // user 정보를 가져온다.
          this.$store.dispatch('SetUserInfo').then(response => {
            // user 정보를 가져온 이후에 이동 및 메뉴 적용
            // this.$store.dispatch('GetMenus')
            // console.log(isMobile())

            // 중간에 인증창이 닫힐시 초기화
            this.modal = false
            this.showCheckEmail = false
            this.disableSendEmail = false

            let grpCd = localStore.get('grp_auth')
            this.loginCount = localStore.get('login_count')
            this.email = localStore.get('email')

            // 관리자 계정 및 Login Retry Count 5회 체크, 체크시 2차 인증으로 이동 2025-01-23 일시 비활성화
            //if (grpCd === 'usergroup001' || this.loginCount > 4) {
            //  this.modal = true
            //} else {
            //  this.process()
            // }

            this.process()
          })
        })
        .catch(reject => {
          // Login이 실패할 경우
          console.error('login fail:', reject)
          this.pwEmpty = false
          this.idEmpty = false
          this.idPwCheck = true

          Message.err('아이디 또는 비밀번호가 다릅니다.')
        })
    },
    goPhoneCertificatePage() {
      this.$router.push('/phoneCertificate')
    },
    toggleContext(index) {
      let contents = this.noticeList[index]

      this.context.type = 'notice'
      this.context.content = contents.content
      this.context.title = contents.title
      this.context.date = contents.insdate

      this.showContext = !this.showContext
    },
    showResource(index) {
      let any = this.resourceList[index]
      console.log(this.resourceList)
      console.log(any)
      this.selectBoard = any
      this.showResourcePopup = !this.showResourcePopup
    },
    closePopup() {
      certificateForEmail(this.certificateNumber).then(res => {
        console.log(res.body)
        if (res.body === 'OK') {
          Message.err('인증이 완료되었습니다.')
          this.modal = false
          this.showCheckEmail = false
          this.disableSendEmail = false
          resetLoginCount()
          this.process()
        } else if (res.body === 'Check') {
          this.modal = false
          this.showCheckEmail = false
          this.disableSendEmail = false
          Message.err('인증번호 미발송 상태입니다. 발송 후 재시도 해주십시오.')
        } else {
          Message.err('인증정보가 올바르지 않습니다. 다시 확인해주십시오.')
        }
      })
    },
    sendEmail() {
      this.showCheckEmail = true
      this.disableSendEmail = true
      checkForEmail(this.email).then(response => {
        console.log('이메일 발송 성공')
      })
    },
    process() {
      this.$store.dispatch('GetUserMenus', store.state.user.userId)

      if (this.is_saved) {
        Cookies.set('saveID', this.userId, { expires: 365 })
      } else {
        Cookies.remove('saveID')
      }
      if (this.isAutoLogin) {
        Cookies.set(
          'autoLogin',
          this.userId + '[####]' + btoa(this.userPassword),
          { expires: 365 }
        )
      } else {
        Cookies.remove('autoLogin')
      }
      this.moveMonitoringPage()
    },
    initPopup() {
      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }
      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
//@import '../../assets/pc_login.less';
// @import '../../assets/new_login.less';
// .cursor {
//   cursor: pointer;
// }
.vapp-root {
  background-image: url('~@/assets/image/bg_web.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 6;
}
.date {
  font-size: 12px;
}
.board_title {
  font-size: 14px;
  margin-left: 8px;
}
.pd0 {
  padding: 0;
}
.pd20 {
  padding: 20px;
}
.mg0 {
  margin: 0;
}
.left_title {
  font-weight: bold;
  font-size: 4rem;
  color: white;
}
.bs_n {
  box-shadow: none !important;
}
.layout {
  width: 80%;
  margin: 0 auto;
}
.btmLine {
  border-bottom: 1px solid #afafaf;
  padding-bottom: 6px;
}
.transpar {
  background-color: #ffffff00 !important;
}
.font-size-btn {
  font-size: 11px;
  cursor: pointer;
  text-decoration: underline;
  color: gray;
}
.font-size-12 {
  font-size: 12px;
}
.font-size-16 {
  font-size: 16px;
}
.font-size-24 {
  font-size: 24px;
}

.font-size-36 {
  font-size: 36px;
}
.callNum {
  font-size: 30px;
  font-weight: bold;
  margin-left: 8px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mt-80 {
  margin-top: 80px;
}
.pd_title {
  padding-top: 16px;
  padding-bottom: 36px;
  padding-left: 0;
}
.pd4-0 {
  padding: 4px 0;
}
.cursor {
  cursor: pointer;
}
.pdLR0 {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #a3a8ae;
}
.bbbbbcolor {
  color: #bbbbbb;
}
.requestAsColor {
  color: #0784f2;
}
.numberColor {
  color: #a3a8ae;
}
.context-list-title {
  width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.big-menu-btn {
  height: 50px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  border-radius: 8px !important;
  text-decoration: none !important;
  letter-spacing: -0.5px;
  padding: 0 !important;
}

.unified-bg {
  background-color: #0784f2 !important;
  color: #ffffff !important;
}

.v-btn__content {
  width: 100%;
}
</style>
